<script>
export default {
  name: 'CloseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 26,
    },
    color: {
      type: String,
      default: '#56AF79',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.726829 0.726829C1.19236 0.261441 1.82367 0 2.48193 0C3.14018 0 3.77149 0.261441 4.23702 0.726829L13.015 9.50479L21.793 0.726829C22.2612 0.27463 22.8882 0.0244124 23.5391 0.0300685C24.19 0.0357245 24.8126 0.296802 25.2729 0.757069C25.7332 1.21734 25.9942 1.83997 25.9999 2.49086C26.0056 3.14175 25.7553 3.76883 25.3031 4.23702L16.5252 13.015L25.3031 21.793C25.7553 22.2612 26.0056 22.8882 25.9999 23.5391C25.9942 24.19 25.7332 24.8126 25.2729 25.2729C24.8126 25.7332 24.19 25.9942 23.5391 25.9999C22.8882 26.0056 22.2612 25.7553 21.793 25.3031L13.015 16.5252L4.23702 25.3031C3.76883 25.7553 3.14175 26.0056 2.49086 25.9999C1.83997 25.9942 1.21734 25.7332 0.757069 25.2729C0.296802 24.8126 0.0357245 24.19 0.0300685 23.5391C0.0244124 22.8882 0.27463 22.2612 0.726829 21.793L9.50479 13.015L0.726829 4.23702C0.261441 3.77149 0 3.14018 0 2.48193C0 1.82367 0.261441 1.19236 0.726829 0.726829Z"
      :fill="color"
    />
  </svg>
</template>
